import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IonTextarea, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';
import { DisclaimersService } from 'src/app/services/disclaimers.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LanguageService } from 'src/app/services/language.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-request-appeal',
  templateUrl: './request-appeal.page.html',
  styleUrls: ['./request-appeal.page.scss'],
})
export class RequestAppealPage  {
  @ViewChild('reason') AppealReason:IonTextarea;
 
  @Input() violation: any;
  appeal:FormGroup= new FormGroup({})
  errors = {};
  constructor(
    private toastSrv:ToastService,
    private errorHandlerSRV:ErrorHandlerService,
    public disclaimerSRV:DisclaimersService,
    private fb: FormBuilder,
    private loaderSRV:LoaderService,
    public modalController: ModalController,
    private dataService: DataService,
    public translateService: TranslateService,
  ) {
    this.appeal = this.fb.group({
      "reason": "",
     
      
    })
  }

  ionViewDidEnter() {
    var disclaimer;
    disclaimer= this.disclaimerSRV.disclaimers.find(disclaimer=>disclaimer['data_trigger']=='appeals-page-loaded' && disclaimer['locale']==this.dataService.selected && disclaimer['content']!=null)
    
    if(disclaimer &&disclaimer['active']){
      
      this.dataService.createAndOpenModal(disclaimer).then(data=>{
        if(data){
          this.AppealReason.setFocus()
        } else {
          this.onCancelModal()
        }
        })
    }  
    
    
  }
  ngAfterViewInit(){
    
  }
  onCancelModal() {
  
    this.modalController.dismiss();
  }
  onSubmitAppeal() {
    this.loaderSRV.showLoader(this.translateService.instant('keys.data.common.loading') || 'Loading...')
    const url = `violations/appeals/${this.violation.ViolationID}`;
    const data = {
      reason:this.appeal.value['reason'],
    };
    this.dataService.postData(url, data).subscribe( {
      next:(res:any)=>{
        this.loaderSRV.dismissLoader()
        if(res?.status=='success'){
          this.toastSrv.presentToast(res?.message)
        } else {
          this.toastSrv.presentErrorToast(res?.message)
        }
        if(res?.reload){
          this.modalController.dismiss({
            reload: true,
          });
        }
       
      },
      error:err=>{
       
        this.errorHandlerSRV.displayErrorMessage(err,true)
      }
       
      }
      
    );
  }
}
